import './index.styl';
import template from './index.jst';

import { View } from 'backbone.marionette';
import Radio from "backbone.radio";
import { User } from '../../../models';

const coachChannel = Radio.channel('coach');
const playerComparisonChannel = Radio.channel('player:comparison');

export class PlayerComparisonNavigation extends View {
	get template() {
		return template;
	}

	get className() {
		return 'player-comparison-nav';
	}

	ui() {
		return {
			tabs: '.js-tab',
			h2h: '.js-h2h-link',
			multi: '.js-multi-player-link',
		}
	}

	events() {
		return {
			'click @ui.h2h': 'jumpToHeadToHeadTab',
			'click @ui.multi': 'jumpToMultiPlayerTab',
		}
	}

	jumpToHeadToHeadTab() {
		playerComparisonChannel.trigger('switch:to:h2h:tab');

		this.ui.tabs.removeClass('active');
		this.ui.h2h.addClass('active');
	}

	jumpToMultiPlayerTab() {
		if (!User.has_assistant_coach) {
			return coachChannel.trigger('show:popup');
		}

		playerComparisonChannel.trigger('switch:to:multi:tab');

		this.ui.tabs.removeClass('active');
		this.ui.multi.addClass('active');
	}
}

export default PlayerComparisonNavigation;